import { EnvelopeSimpleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Email = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <EnvelopeSimpleIcon size={Sizes[size]} color={fill} {...rest} />;
};

Email.displayName = 'Email';
